import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function ThreeSubjectsIllustration({
  achievementId,
  variant = 'frost',
  // Unlocks frost variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4112" data-mp="2l01jg6osnwe7">
      <div className="relative w-full h-full bg-gradient-to-b from-sky-200 to-blue-400 overflow-hidden" data-id="element-4113" data-mp="2g8jqo5wxd24b">
        {/* Background: 3 Pillars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4114" data-mp="2b85hulni1o58">
          {/* Left Pillar */}
          <rect x="20" y="80" width="30" height="120" fill="#BAE6FD" data-id="element-4115" data-mp="1xaqoj5u4kw7z" />
          <rect x="25" y="80" width="10" height="120" fill="#E0F2FE" data-id="element-4116" data-mp="1xbijqfjt8rxq" />
          <polygon points="20,80 50,80 35,60" fill="#7DD3FC" data-id="element-4117" data-mp="1p0ggfvlpp3bf" />

          {/* Right Pillar */}
          <rect x="150" y="80" width="30" height="120" fill="#BAE6FD" data-id="element-4118" data-mp="1tt9lylp08fok" />
          <rect x="155" y="80" width="10" height="120" fill="#E0F2FE" data-id="element-4119" data-mp="1g137r55ewirr" />
          <polygon points="150,80 180,80 165,60" fill="#7DD3FC" data-id="element-4120" data-mp="1fyqis818l857" />

          {/* Center Pillar (Behind Djay) */}
          <rect x="80" y="120" width="40" height="80" fill="#7DD3FC" data-id="element-4121" data-mp="28pijnit8ykyv" />
          <rect x="85" y="120" width="15" height="80" fill="#BAE6FD" data-id="element-4122" data-mp="28qa2dt1qwo7q" />
          <polygon points="80,120 120,120 100,100" fill="#38BDF8" data-id="element-4123" data-mp="2cq2gsmdtlol0" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-4124" data-mp="1yqj89sh3kb86">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-4125" data-mp="23pcnpqfy2caz">
            <DjaySpecimen look={{
            variant,
            accessory: 'tripleStars'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'pointing'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4126" data-mp="ncfiyzlgfb9g" />
          </div>
        </div>

        {/* Foreground: Frost/Magic effects */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4127" data-mp="3vl6orois47zp">
            <circle cx="35" cy="50" r="8" fill="#FDE047" opacity="0.8" filter="blur(2px)" data-id="element-4128" data-mp="3lplr22kqttvr" />
            <circle cx="165" cy="50" r="8" fill="#FDE047" opacity="0.8" filter="blur(2px)" data-id="element-4129" data-mp="3codvvtdix95w" />
            <circle cx="100" cy="90" r="10" fill="#FDE047" opacity="0.6" filter="blur(3px)" data-id="element-4130" data-mp="1aw92sekag5tl" />

            <path d="M35 40 L35 60 M25 50 L45 50" stroke="white" strokeWidth="2" data-id="element-4131" data-mp="1dh7524tvw844" />
            <path d="M165 40 L165 60 M155 50 L175 50" stroke="white" strokeWidth="2" data-id="element-4132" data-mp="1idxgufynohjq" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}